module.exports = __webpack_public_path__ + "static/media/imac-scrn-code.52cae089.jpg";